import React from 'react';
import { useIntl } from 'react-intl';
import { useAtomValue } from 'jotai';
import { useFormContext } from 'react-hook-form';
import { themeAtom } from '../../../../../Atoms';
import { Typography, Box } from '@mui/material';
import EventIcon from '@mui/icons-material/Event';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import PeopleAltRoundedIcon from '@mui/icons-material/PeopleAltRounded';
import {
  FullSizeColumn,
  FullSizeFlexBox,
} from '../../../../../Components/FlexBox';
import ListInfo from '../../../DetailsSection/DataDetailsBox/ListInfo';
import { createNewDate, culture } from '../../../../../Helpers/dates';

const Summary = function Summary() {
  const intl = useIntl();
  const currentTheme = useAtomValue(themeAtom);
  const { getValues } = useFormContext();
  const { scheduledOn, assignee, notes, remindBefore } = getValues();

  return (
    <FullSizeColumn gap="16px">
      {scheduledOn && (
        <ListInfo
          icon={<EventIcon />}
          title={`${intl.messages.DAY}: `}
          value={createNewDate(scheduledOn).toLocaleDateString(culture, {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
          })}
        />
      )}
      {assignee && (
        <ListInfo
          icon={<PeopleAltRoundedIcon />}
          title={`${intl.messages.ASSIGNEE}: `}
          value={assignee === 'ALL' ? intl.messages.ALL : assignee}
        />
      )}
      {remindBefore && (
        <ListInfo
          icon={<NotificationsRoundedIcon />}
          title={`${intl.messages.REMINDBEFORE}: `}
          value={
            remindBefore
              ? `${remindBefore} ${intl.messages.MINUTES_BEFORE}`
              : intl.messages.NO_REMINDER
          }
        />
      )}
      {notes ? (
        <FullSizeFlexBox
          sx={{
            padding: '16px',
            backgroundColor:
              currentTheme === 'dark' ? 'greys.darker' : '#ededed',
            color: '#111',
            borderRadius: '18px',
            flexGrow: 1,
          }}
        >
          <Box
            sx={{
              height: "100%",
              width: "100%",
              overflow: "auto"
            }}>
            <Typography variant="body1" style={{ whiteSpace: 'pre-wrap' }}>
              {notes}
            </Typography>
          </Box>
        </FullSizeFlexBox>
      ) : (
        <Typography variant="body1">{intl.messages.NO_NOTES}</Typography>
      )}
    </FullSizeColumn>
  );
};

export default Summary;
